import { render } from "./AdminSidebar.vue?vue&type=template&id=63e5b486&scoped=true"
import script from "./AdminSidebar.vue?vue&type=script&lang=js"
export * from "./AdminSidebar.vue?vue&type=script&lang=js"

import "@/assets/AdminSidebar.css?vue&type=style&index=0&id=63e5b486&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63e5b486"]])

export default __exports__